<wl-content-section [id]="id()" [theme]="theme()" [hasContext]="!!context()">
  @if (viewModel$ | async; as vm) {
    <div>
      <div id="storeProductOverview" class="pb-4">
        <wl-generic-offer-container
          [products]="vm.products"
          [listName]="productListName"
        >
          <ng-template let-implicitProduct let-context="context">
            @if (stronglyTypedProduct(implicitProduct); as product) {
              <div class="h-100">
                <wl-generic-offer
                  [rendering]="rendering()"
                  [wlTrackProduct]="{
                    track: product,
                    trackingConfig: trackProductConfig,
                    context: context,
                    trackMode: 'product-impression',
                  }"
                  [product]="product"
                  (clicked)="onSelect(product)"
                  [buttonTextField]="
                    !allowMultipleProductsSelection
                      ? nextPageButtonTextField
                      : undefined
                  "
                  [selected]="
                    allowMultipleProductsSelection &&
                    productSelected(vm.selectedProducts, product)
                  "
                  [mode]="allowMultipleProductsSelection ? 'select' : 'display'"
                  class="d-flex h-100"
                  (secondaryClicked)="handleSecondaryButtonClick($event)"
                >
                  @if (product.price || allowMultipleProductsSelection) {
                    <div bottom class="p-2">
                      @if (showPrices()) {
                        <div class="d-flex justify-content-center">
                          @if (product.price && product.rentPrice) {
                            <eplus-price-info-container
                              [product]="product"
                              [fields]="rendering().fields"
                            />
                          } @else if (product.price && !product.rentPrice) {
                            <wl-generic-price-info
                              [prefixLabel]="
                                rendering().fields.ProductPricePrefixLabel
                              "
                              [suffixLabel]="suffixLabel(product)"
                              [price]="product.price"
                            />
                          }
                        </div>
                      }

                      @if (allowMultipleProductsSelection) {
                        <wl-toggle-with-info
                          [rendering]="rendering()"
                          [title]="toggleProductTitle"
                          [description]="toggleProductDescription"
                          toggleId="generic-product-toggle-{{ context.index }}"
                          [checked]="
                            productSelected(vm.selectedProducts, product)
                          "
                          (toggle)="onSelect(product)"
                        ></wl-toggle-with-info>
                      }
                    </div>
                  }
                </wl-generic-offer>
              </div>
            }
          </ng-template>
        </wl-generic-offer-container>
      </div>

      @if (allowMultipleProductsSelection) {
        <div class="row justify-content-center">
          <div class="col-6 col-md-4">
            <button
              [disabled]="vm.selectedProducts.length === 0"
              type="submit"
              class="btn btn-sales-primary w-100"
              (click)="onSubmit($event)"
              *scText="nextPageButtonTextField"
              wlAutomationId="next-page-button"
            ></button>
          </div>
        </div>
      }
    </div>
  }
</wl-content-section>
